module.exports = __webpack_public_path__ + "img/vocational.749d13b0.webp";